<script setup lang="ts">
import { CloseCircleIcon } from '@fond-of/satch-icons'

const props = defineProps<{ handleClick: () => void }>()
</script>
<template>
  <button
    :class="[
      'bg-gray-ultra-light border-none p-1.5 text-black',
      'group-has-[:focus]:bg-white',
      'h-[46px] w-[46px] border-none md:h-[52px] md:w-[52px]',
      'size-[46px] border-none md:size-[52px]',
    ]"
    type="reset"
    data-slot="icon"
    aria-label="Clear Searchbar"
    @click="props.handleClick"
  >
    <CloseCircleIcon class="size-6" />
  </button>
</template>
